import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import BundleChapterOverView from "./BundleChapterOverView";
import { useState } from "react";
import { Loading } from "@pages/Other/Loading";
import RenderRating from "@pages/Other/StarRating/RenderRating";
import CartButton from "../CourseTile/CartButton/CartButton";
import moment from "moment/moment";
import Share from "../CourseShare/courseShare";
const { REACT_APP_LOGIN_API_BASEURL } = process.env;
const BundleDetail = ({ match }) => {
  const { loggedIn } = useSelector((state) => state.authentication);
  const { id } = useParams();
  const { t } = useTranslation();

  const [bundleDetails, setBundleDetails] = useState(null);
  const [shareShow, setShareShow] = useState(false);
  const bundleId = id.match(/\w[^-]*$/g);

  const handleClose = () => {
    setShareShow(!shareShow);
  };

  const fetch = async (bundleId) => {
    try {
      setBundleDetails(null);
      const res = await axios.get(`${REACT_APP_LOGIN_API_BASEURL}/v2/bundles/${bundleId}`);
      setBundleDetails(res?.data?.data);
    } catch (error) {
      console.error("Error fetching bundle details:", error);
    }
  };

  useEffect(() => {
    if (bundleId != null) {
      fetch(bundleId[0]);
    }
  }, []);


  return (
    <>
      {bundleDetails ? (
        <div>
          <div className="min-div">
            <div className="inner-div">
              <div className="flex-wrap">
                <div>{bundleDetails.name}</div>
                {loggedIn &&
                  <div className="int-flex-wrapper">
                    <div className="wishlist-wrapper">
                      <span className="icon icon-like"></span>
                    </div>
                    <div className="share-course-wrapper" onClick={handleClose}>
                      <i className="topic-share-icon"></i>
                    </div>
                  </div>
                }
              </div>

              <div className="course-banner-main">
                <div className="banner-course-left">
                  <div className="course-header">{bundleDetails.name}</div>
                  <div className="banner-sub">
                    {bundleDetails.bundleOneLiner}
                  </div>
                  <div className="EnrollmentFee">
                    <div className="course-price-wrapper">
                      <div className="course-price">
                        <span>{bundleDetails && bundleDetails.price}</span>
                      </div>
                      <div className="coupon-code">
                        <ul>
                          <li>Got a Discount code?</li>
                          <li></li>
                        </ul>
                      </div>
                    </div>
                    <div className="star-rateingmenu">
                      <div className="rating-title">
                        <div className="sub-title">{t("Reviews")}</div>
                        <div className="ratings-wrapper">
                          <RenderRating ratings={Number(3)} />
                          <div className="rate-course-title">
                            {t("Rate this Course?")}
                          </div>
                        </div>
                      </div>
                      <div>
                        <p className="sub-title">{t("Bundle views")} &nbsp;</p>
                      </div>
                    </div>
                  </div>

                  <div className="banner-profile-div">
                    <div className="banner-profile-left">
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/147/147144.png"
                        alt=""
                      />
                    </div>

                    <div className="banner-profile-right">
                      <div className="banner-header">yslearn Instructor</div>
                      <div className="banner-sub-text">
                        {t("Admin Profile")}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="banner-course-right">
                  <div className="flex-right">
                    <ul>
                      <li className="Basket">
                        <CartButton
                          post={{ ...bundleDetails, ID: parseInt(bundleDetails.ID) }}
                          bundle={true}
                        />
                      </li>
                    </ul>
                    <div className="course-info-wrapper">
                      <div className="banner-sub2">
                        <ul>
                          <li>{t("Languages")}:</li>
                          <li>{t("English")}</li>
                        </ul>
                      </div>

                      <div className="banner-sub2">
                        <ul>
                          <li>
                            {t("Created on")}:{" "}
                            {moment(bundleDetails?.CreatedOn).format(
                              "MMM DD, YYYY"
                            )}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <BundleChapterOverView bundleDetails={bundleDetails} />

          {shareShow && <Share handleClose={handleClose} />}
        </div>
      ) : (
        <div className="loading-div">
          <Loading />
        </div>
      )}
    </>
  );
};

export default BundleDetail;
